import { Card } from 'antd';
import type { CardProps } from 'antd';

export interface DCardProps extends CardProps {}

export const DarwinCard = (props: DCardProps) => {
  return <Card {...props} />;
};
